/*
 * 报价管理
 */

import EmptyRouter from '@/layout/EmptyRouter.vue';
import EmptyRouterAlive from '@/layout/EmptyRouterAlive.vue';

export default {
    path: 'WMS',
    name: 'WMSPage',
    component: EmptyRouterAlive,
    meta: {
      title: 'WMS',
    },
    children: [
    {
      path: 'waveList',
      name: 'WMSWavePage',
      component: EmptyRouter,
      redirect: 'waveList/index',
      meta: {
        title: '波次列表',
      },
      children: [
        {
          path: 'index',
          name: 'WMSWavePage',
          component: () => import('@/views/center-business/WMS/waveList'),
          meta: {
            title: '波次列表',
            isCache: true,
          },
        },
        {
            path: 'detail',
            name: 'WMSWaveDetail',
            component: () => import('@/views/center-business/WMS/waveDetail'),
            meta: {
              title: '波次详情',
            },
            hidden: true,
          },
      ],
    },
    {
      path: 'sortingStation',
      name: 'WMSSortingStation',
      component: EmptyRouter,
      redirect: 'sortingStation/index',
      meta: {
        title: '分拣台列表',
      },
      children: [
         {
          path: 'index',
          name: 'WMSSortingStation',
          component: () => import('@/views/center-business/WMS/sortingStation'),
          meta: {
            title: '分拣台列表',
            isCache: true,
          },
        },
      ],
    },
    {
      path: 'LampRack',
      name: 'WMSLampRack',
      component: EmptyRouter,
      redirect: 'LampRack/index',
      meta: {
        title: '灯架配置',
      },
      children: [
         {
          path: 'index',
          name: 'WMSLampRack',
          component: () => import('@/views/center-business/WMS/LampRack'),
          meta: {
            title: '灯架配置',
            isCache: true,
          },
        },
      ],
    },
    {
      path: 'NSTD',
      name: 'WMSNSTD',
      component: EmptyRouter,
      redirect: 'NSTD/index',
      meta: {
        title: 'NSTD',
      },
      children: [
         {
          path: 'index',
          name: 'WMSNSTD',
          component: () => import('@/views/center-business/WMS/NSTD'),
          meta: {
            title: 'NSTD',
            isCache: true,
          },
        },
      ],
    },
  ],
};
